import React from 'react';
import { FormattedMessage } from 'react-intl';
import { UserDisplayName } from '..';
import { formatResponseTime } from '../../util/responseTime';
import css from './InboxProviderResponseRate.module.css';

const InboxProviderResponseRate = ({ provider, intl }) => {
  const responseMetrics = provider?.attributes?.profile?.metadata?.metrics?.responseTime;
  const hasResponseData = responseMetrics && responseMetrics.last30DaysAverageHours;

  if (!hasResponseData) {
    return null;
  }

  return (
    <div className={css.root}>
      <UserDisplayName user={provider} intl={intl} useOnlyFirstName />
      &nbsp;
      <FormattedMessage
        id="InboxProviderResponseRate.responseTime"
        values={{
          responseTime: formatResponseTime(responseMetrics.last30DaysAverageHours),
        }}
      />
    </div>
  );
};

export default InboxProviderResponseRate;
